import { match } from 'ts-pattern';

import { parseRateInput } from '@/entities/service-catalog';
import type { ScheduleSessionInput } from '@/entities/session';
import { buildLocalInstant } from '@/shared/lib/time-utils';

import type { ScheduleSessionFormOutput } from '../model/schedule-session-form.schema';
import { parseTimeOfDay } from './parse-time-of-day';

function buildLocation(values: ScheduleSessionFormOutput): ScheduleSessionInput['location'] {
    return match(values.locationType)
        .with('IN_PERSON', (type) => ({ type, practiceLocationId: values.practiceLocationId }))
        .with('TELEHEALTH', (type) => ({ type, link: values.telehealthLink }))
        .with('PHONE', (type) => ({ type, phoneNumber: values.phoneNumber }))
        .exhaustive();
}

// The schema already refused an unparseable or missing time, so `parseTimeOfDay` never actually
// returns null here.
export function buildScheduleSessionInput(values: ScheduleSessionFormOutput): ScheduleSessionInput {
    const startMinutes = parseTimeOfDay(values.startTime) ?? 0;
    const endMinutes = parseTimeOfDay(values.endTime) ?? 0;

    const start = buildLocalInstant(values.date, startMinutes).date;
    const end = buildLocalInstant(values.date, endMinutes).date;

    return {
        clientIds: [values.client.id],
        date: start.toISOString(),
        duration: (end.getTime() - start.getTime()) / 60_000,
        location: buildLocation(values),
        serviceCode: values.serviceCode,
        feeCents: parseRateInput(values.fee),
        inputMethod: null,
    };
}
